/**
 * AnalyticsHelper class to intentionally no-op external analytics.
 * @class AnalyticsHelper
 */
export class AnalyticsHelper {
  /**
   * @constructor
   * @param {Object} [options={}] - options for analytics
   * @param {string} [options.token] - analytics token
   * @param {boolean} [options.enabled] - external analytics flag
   */
  constructor({ token: analyticsToken, enabled = false } = {}) {
    this.analyticsToken = analyticsToken;
    this.enabled = enabled;
    this.analytics = null;
    this.user = {};
  }

  /**
   * Initialize analytics
   * @function
   * @async
   */
  async init() {
    return undefined;
  }

  /**
   * Identify the user
   * @function
   * @param {Object} user - User object
   */
  identify(_user) {
    return undefined;
  }

  /**
   * Track any event
   * @function
   * @param {string} eventName - event name
   * @param {Object} [properties={}] - event properties
   */
  track(_eventName, _properties = {}) {
    return undefined;
  }

  /**
   * Track the page views
   * @function
   * @param {string} pageName - Page name
   * @param {Object} [properties={}] - Page view properties
   */
  page(_pageName, _properties = {}) {
    return undefined;
  }
}

// This object is shared across, the init is called in app/javascript/entrypoints/dashboard.js
export default new AnalyticsHelper(window.analyticsConfig);
